const en_sales_po = {
    label: {
        process_so: "proses SO"
    }
}

export default en_sales_po;